import * as React from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import CustomerContractList from '../components/CustomerContractList';
import PageHeader from '../components/common/PageHeader';
import PageContainer from '../components/common/PageContainer';

export default function Contracts() {
  const [tab, setTab] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <PageContainer>
      <PageHeader title="契約管理" />
      <Tabs value={tab} onChange={handleChange}>
        <Tab label="顧客契約" />
        <Tab label="案件契約" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {/* xlsx 行64: 顧客契約と案件契約は同一データ。両タブとも同じ CustomerContractList を表示し、
            「契約管理」と「案件詳細→契約タブ」で同じ Contract を参照する。
            将来、案件視点での絞り込み/ソートが必要になれば ProjectContractList を分離。 */}
        {tab === 0 && <CustomerContractList />}
        {tab === 1 && <CustomerContractList />}
      </Box>
    </PageContainer>
  );
}
